<template>
  <div class="col mx-auto">
    <div class="row mt-2">
      <div class="col-12 mx-auto p-0">
        <button class="btn wfh-btn-link-primary p-0" @click="openAdvancedFilterModal()">
          Advanced Filter
        </button>
      </div>
    </div>

    <div class="row align-content-center" style="min-height: 350px;" v-if="pageLoadReady && hasNoTasks">
      <div class="col-12 mx-auto text-center">
        <img src="/images/EmptyState.svg" alt="No Assigned Tasks">
      </div>
      <div class="col-12 mx-auto text-center mt-3">
        <div class="empty-state-title">No Task Yet</div>
        <p class="empty-state-description">We are searching for the right task for you, please come back
          later </p>
      </div>
    </div>

    <div class="row mt-2" style="min-height: 350px;" v-else>
      <div class="col-12 mx-auto p-0">
        <playable-task-item
            v-for="(task, key) in tasks"
            :key="key"
            :task="task"
            :activeTask="activeTaskId"
            @taskPlayed="handleTaskPlayed"
        ></playable-task-item>
      </div>
    </div>

    <div class="row">
      <div class="col-auto mx-auto">
        <button
            class="btn wfh-btn-link-primary"
            :disabled="page >= lastPage || this.tasks.length === 0"
            @click="fetchNextTasks()"
        >
          Show More
        </button>
      </div>
    </div>

    <transition name="fade">
      <advanced-task-filter-modal
          :existingFilters="advancedFilters"
          v-if="showAdvancedFilterModal"
          @close="closeAdvancedTaskFilterModal"
          @submit="handleAdvancedFilter"
      ></advanced-task-filter-modal>
    </transition>
  </div>
</template>

<script>
import Task from '../../../Task/Task';

export default {
  data () {
    return {
      tasks: [],
      pageLoadReady: false,
      localShowGuide: true,
      taskService: Task,
      activeTaskId: null,
      showAdvancedFilterModal: false,
      advancedFilters: [],
      page: 1,
      lastPage: 1,
    };
  },

  computed: {
    showGuide () {
      return !localStorage.getItem('wfh-show_task_guide') && this.localShowGuide && this.hasNoTasks;
    },

    hasNoTasks () {
      return this.pageLoadReady && this.tasks.length === 0;
    },
  },

  methods: {
    toggleCheckbox (taskKey) {
      this.tasks = this.tasks.map((task, key) => {
        return key === taskKey ? {
          ...task,
          completed_at: !task.completed_at,
        } : task;
      });
    },

    fetchNextTasks () {
      this.page++;
      this.fetchUserTasks();
    },

    async fetchUserTasks () {
      const filters = {
        assigned_to: 'personal',
        type: 'todo',
        range: 'today',
        status: 'today',
        per_page: 15,
        page: this.page,
        for_external: true,
      };

      if (this.advancedFilters !== null) {
        filters['advanced_filters'] = this.advancedFilters;
      }

      const res = await this.taskService.fetchTasks(filters);

      this.tasks = [...this.tasks, ...res.data];
      this.lastPage = res.last_page;
      this.pageLoadReady = true;
    },

    isCompleted (task) {
      return !!task.completed_at;
    },

    handleTaskPlayed (id) {
      this.activeTaskId = id;
    },

    async handleAdvancedFilter (filters) {
      this.advancedFilters = filters;
      this.reset();
      this.closeAdvancedTaskFilterModal();

      await this.fetchUserTasks();
    },

    reset () {
      this.tasks = [];
      this.pageLoadReady = false;
    },

    openAdvancedFilterModal () {
      this.showAdvancedFilterModal = true;
    },

    closeAdvancedTaskFilterModal () {
      this.showAdvancedFilterModal = false;
    },
  },

  mounted () {
    this.fetchUserTasks();
  },
};
</script>

<style scoped>

</style>
